import { render } from "./BalanceHis.vue?vue&type=template&id=069a1a68&scoped=true"
import script from "./BalanceHis.vue?vue&type=script&lang=js"
export * from "./BalanceHis.vue?vue&type=script&lang=js"

import "./BalanceHis.vue?vue&type=style&index=0&id=069a1a68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069a1a68"]])

export default __exports__